

export const soraHero = {
    title: 'Sora 2 AI Video Generator',
    tags: 'No Watermark • No Invitation Code • No App Download',
    desc:
      "Experience OpenAI's latest Sora 2 model. Transform text or images into stunning, realistic videos with advanced motion and physics consistency. Perfect for creative projects and social media."
  };
